import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import { getDeliveryAddress } from "../../../../redux/savedaddress/SavedAddressAction";
import axios from "axios";
import AddAddress from "../pop-ups/AddAddress";
import { Modal } from "react-bootstrap";
import { getFirebaseAnalyticsInstance } from "../../../../firebase";
import ReactGA from 'react-ga';
import Button from "react-bootstrap/Button";
import Closeicon from "./../../../../../src/assets/images/SheetClose.svg";

export default function DeliveryAddresses(props) {
  console.log(props, "sdfsdfsdf")
  const {
    parentAreaId,
    parentCityId,
    homeServiceQuantity,
    selectedAddressListCallBack,
    partnerName,
    selectedRecipaintId,
  } = props;

  console.log(selectedRecipaintId, "selectedRecipasdasdaintId")
  const cartState = useSelector((state) => state.cartsData);
  const focusPoint = useRef(null);

  const dispatch = useDispatch();
  const deliveryAddress = useSelector((state) => state.savedAddressReducers);
  const user = useSelector((state) => state.auth);
  const [selectOptions, setSelectOptions] = useState([]);
  console.log(selectOptions,"selectOptions")
  const [selectedAddresses, setSelectedAddress] = useState([]);
  const [displayAddr, setDisplayAddress] = useState([]);
  const [finalAddressList, setFinalAddressList] = useState([]);
  const [addressPopup, setAddressPopup] = useState(false);
  const [addressDetails, setAddressDetails] = useState();

  const [testAddress, settestAddress] = useState("tests");

  const [cityId, setCityId] = useState([]);
  const [areaId, setAreaId] = useState([]);

  const cities = useSelector((state) => state.auth.cities);
  const areas = useSelector((state) => state.auth.areas);

  const savedArea = useSelector((state) => state.area);
  const savedCity = useSelector((state) => state.city);

  useEffect(() => {
    dispatch(getDeliveryAddress(user.uuid));
    getCityAndArea();
  }, []);

  useEffect(() => {
    let data = [];
    deliveryAddress &&
      deliveryAddress.addressData &&
      deliveryAddress.addressData.length > 0 &&
      deliveryAddress.addressData.map((address) => {
        console.log(address,"address")
        let mData =
          address?.patientName +
          ",  " +
          address?.addressLine +
          ",      \n" +
          address && address?.areaDetails && address?.areaDetails[0] && address?.areaDetails[0]?.name +
          ",   \n" +
          address && address?.cityDetails && address?.cityDetails[0] && address?.cityDetails[0]?.name +
          ",     \n";

          const data11 = `${address && address?.patientName}${(address && address?.patientName && address && address?.addressLine) && ', '}${address && address?.addressLine}${address?.areaDetails && address?.areaDetails[0]?.name && ', '} ${address?.areaDetails && address?.areaDetails[0]?.name}${address?.cityDetails && address?.cityDetails[0]?.name && ', '}${address?.cityDetails && address?.cityDetails[0]?.name}`
          console.log(data11,"address1")

        data.push({
          // name : mData,
          // name: address?.patientName + ',' + address?.addressLine + ',' + address?.areaDetails && address?.areaDetails[0]?.name + ',' + address?.cityDetails && address?.cityDetails[0]?.name,
          name: data11,
          id: address._id,
          labName: partnerName,
          data: address,
        });
        console.log(address, 'selectedRecipaintId')
      });
    setSelectOptions(data);
  }, [deliveryAddress]);

  useEffect(() => {
    displayAddress();
  }, [selectedAddresses]);

  useEffect(() => {
    // Add data to parent (props)
    console.log(finalAddressList);
  }, [finalAddressList]);

  const getCityAndArea = async () => {
    cities.forEach((city) => {
      if (city.name === savedCity.label) {
        setAreaId(city._id);
      }
    });

    areas.forEach((area) => {
      if (area.name === savedArea.area.label) {
        setCityId(area._id);
      }
    });
  };

  const onSelect = async (selectedList) => {
    saveData(selectedList);
    // getFirebaseAnalyticsInstance().logEvent('Delivery Address', selectedList)
    // try {
    //   await getFirebaseAnalyticsInstance().logEvent("USER_LOGIN", {
    //     eventType: "LOGIN",
    //     platform: "web",
    //   });
    // } catch (error) {
    //   console.log(error);
    // }
    ReactGA.event({
      category: 'Delivery Address',
      action: selectedList,
      label: 'Delivery Address',
    })
  }

  function onRemove(selectedList) {
    saveData(selectedList);
  }

  const saveData = (selectedData) => {
    if (selectedData.length == 0) {
      setSelectedAddress([]);
      selectedAddressListCallBack([{ labName: partnerName }]);
    } else {
      let data = [];
      let dataToSend = [];

      selectedData.map((address) => {
        data.push(address);
      });

      setSelectedAddress(data);
      console.log(data, "fsadadasd")

      selectedData.map((address) => {
        let formatedAddress = address;
        delete formatedAddress.data["areaDetails"];
        delete formatedAddress.data["cityDetails"];
        formatedAddress.data["lab_partner_name"] = partnerName;
        dataToSend.push(formatedAddress);
      });

      setFinalAddressList(dataToSend);
      selectedAddressListCallBack(dataToSend);
    }
  };

  const displayAddress = () => {
    let data = [];
    if (selectedAddresses && selectedAddresses.length > 0) {
      selectedAddresses.map((address) => {
        data.push(
          <div
            style={{
              width: "100%",
              marginBottom: "10px",
              background: "#f7f8fb",
            }}
          >
            <p>{`Patient Name : ${address.data.patientName}`}</p>
            <p>{`Address : ${address.data.addressLine}`}</p>
            <p>{`City : ${address.data.cityDetails &&
              address.data.cityDetails[0] &&
              address.data.cityDetails[0].name
              ? address.data.cityDetails[0].name
              : "NA"
              } `}</p>
            <p>{`Area : ${address.data.cityDetails &&
              address.data.areaDetails[0] &&
              address.data.areaDetails[0].name
              ? address.data.areaDetails[0].name
              : "NA"
              }`}</p>
            {/* <Button onClick={() => {
                            setAddressPopup(true);
                            setAddressDetails(address.data)
                            setDisplayAddress([])
                            focusPoint.current.resetSelectedValues()
                        }}> Edit </Button> */}
            <hr></hr>
            <br></br>
          </div>
        );
      });
    } else {
      data.push(null);
    }

    setDisplayAddress(data);
  };

  return (
    <>
      <div style={{ display: "flex", gap: "16px" }}>
        <div style={{ width: "100vw" }} className="address-div">
          <Multiselect
            ref={focusPoint}
            customCloseIcon={<img src={Closeicon} style={{ width: '25px' }} />}
            options={selectOptions && selectOptions}
            onSelect={onSelect}
            onRemove={onRemove}
            displayValue="name"
            showCheckbox={true}
            selectionLimit={homeServiceQuantity}
            placeholder={"Select Home Sample Collection Address"}
            selectedValues={selectedRecipaintId}
            showArrow={true}
            // selectedValues={testAddress}
            // defaultValue={testAddress}
            style={{
              width: "100vw",
              innerHeight: "400%",
              inputField: {
                // To change input field position or margin
                margin: "5px",
                minWidth: "300px",
              },
              chips: {
                // To change css chips(Selected options)
                background: "#F7F8FB",
                color: "black",
              },
              searchBox: {
                // To change search box element look
                color: "black",
              },
              optionContainer: {
                // To change css for option container
                border: "1px solid #E3EAF6",
              },
              option: {
                // To change css for dropdown options
                border: "1px solid #E3EAF6",
                background: "#E3EAF6",
                color: "#191716",
                margin: "5px",
                innerHeight: "100vh",
                // outerHeight: "100vh",
              },
            }}
          />
        </div>
        {/* <div style={{ width: "70%", padding: "0 16px" }}>{displayAddr}</div> */}
      </div>
      <Modal
        backdrop="static"
        show={addressPopup}
        onHide={() => setAddressPopup(false)}
      >
        {/* Id 1 for Edit Address */}
        <AddAddress
          id={1}
          close={() => setAddressPopup(false)}
          cartId={
            cartState.data.fulldetails &&
            cartState.data.fulldetails[0] &&
            cartState.data.fulldetails[0].uuid
          }
          recipients={cartState && cartState.relatives}
          itemDetails={addressDetails}
        />
      </Modal>
    </>
  );
}
